import { useState, useEffect, useRef, useMemo } from "react";
import css from "./pathways.module.scss";
import "./style.scss"
import { Layout } from "../../componentsV1/layout";
import Logo from "../../assets/v1/logo.png";
import { Antibody, Stack, Graph, Target, Link, CheckCircle } from "../../assets/v1/icons";
import Dropdown from "../../components/Dropdown"
import { ProteinMapHR } from "./Maps/ProteinMapHR"
import { ProteinMapSSB } from "./Maps/ProteinMapSSB"
import { ProteinMapNHEJ } from "./Maps/ProteinMapNHEJ"
import { ProteinFunction } from "./proteinFunction";
import TipImg from "../../assets/v1/pathways/tip.png"
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { proteinFunctions, ssbProteinFunctions, nhejProteinFunctions } from '../../utils/proteinName'
import ReactPrint from "react-to-print";
import NHEJ from "../../assets/v1/pathways/nhej.svg"
import SSB from "../../assets/v1/pathways/ssb.svg"
import HR from "../../assets/v1/pathways/hr.svg"

export const Pathways = () => {
  const params = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const tipRef = useRef(null)
  const printRef = useRef(null)
  const getMapFromPath = (path) => {
    if (path.endsWith('/dsbhr')) {
      return { label: 'Homologous Recombination', value: 'HR' };
    } else if (path.endsWith('/dsbnhej')) {
      return { label: 'Non Homologous End Joining', value: 'NHEJ' };
    } else {
      return { label: 'Single Strand Break', value: 'SSB' };
    }
  };

  const [selectedMap, setSelectedMap] = useState(() => getMapFromPath(pathname));
  const [selectedProtein, setSelectedProtein] = useState(null)
  const [openTip, setOpenTip] = useState(false)

  useEffect(() => {
    setSelectedMap(getMapFromPath(pathname));
  }, [pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tipRef.current && !tipRef.current.contains(event.target)) {
        setOpenTip(false)
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  }, []);

  const renderMap = () => {
    switch (selectedMap?.value) {
      case 'SSB':
        return <ProteinMapSSB setSelectedProtein={setSelectedProtein} selectedProtein={selectedProtein} />;
      case 'NHEJ':
        return <ProteinMapNHEJ setSelectedProtein={setSelectedProtein} selectedProtein={selectedProtein} />;
      case 'HR':
      default:
        return <ProteinMapHR setSelectedProtein={setSelectedProtein} selectedProtein={selectedProtein} />;
    }
  };

  const renderMapSvg = () => {
    switch (selectedMap?.value) {
      case 'SSB':
        return <div style={{ display: 'none' }}>
          <img src={SSB} alt="" width={'100%'} height={'100%'} ref={printRef} />
        </div>
      case 'NHEJ':
        return <div style={{ display: 'none' }}>
          <img src={NHEJ} alt="" width={'100%'} height={'100%'} ref={printRef} />
        </div>
      case 'HR':
      default:
        return <div style={{ display: 'none' }}>
          <img src={HR} alt="" width={'100%'} height={'100%'} ref={printRef} />
        </div>
    }
  }

  const proteinInfo = useMemo(() => {
    if (selectedMap?.value === 'SSB') {
      return ssbProteinFunctions.find((item) => item.name === selectedProtein)
    } else if (selectedMap?.value === 'NHEJ') {
      return nhejProteinFunctions.find((item) => item.name === selectedProtein)
    } else {
      return proteinFunctions.find((item) => item.name === selectedProtein)
    }
  }, [selectedProtein])


  return (
    <Layout>
      <div className={css.heroContainer}>
        <div className={css.heroContent}>
          <img src={Logo} alt="logo" className={css.heroLogo} />
          <div className={css.heroText}>
            <h1>Explore the Pathways Behind DNA Damage and Repair</h1>
            <div className={css.line} />
            <p>Curated molecular pathway maps for DNA damage signaling and repair. Navigate key mechanisms. Discover targets. Advance your research.</p>
          </div>
        </div>
      </div>
      <div className={`${css.section} ${selectedProtein ? css.showProduct : css.hideProduct}`}>
        <div className={css.selectionContainer}>
          <div className={css.mapContainer}>
            <div className={css.filtersContainer}>
              <Dropdown
                optionType='object'
                options={[
                  {
                    label: 'Homologous Recombination',
                    value: 'HR'
                  },
                  {
                    label: 'Single Strand Break',
                    value: 'SSB'
                  },
                  {
                    label: 'Non Homologous End Joining',
                    value: 'NHEJ'
                  }
                ]}
                value={selectedMap?.label}
                onChange={(e) => {
                  setSelectedMap(e);
                  if (e.value === 'HR') navigate('/v1/product/pathways/dsbhr');
                  else if (e.value === 'SSB') navigate('/v1/product/pathways/ssb');
                  else if (e.value === 'NHEJ') navigate('/v1/product/pathways/dsbnhej');
                }}
                className={css.dropdown}
              />
              <ReactPrint
                trigger={() => <span className={css.mapViewBtn}>
                  See Full Map</span>}
                content={() => printRef.current}
              />
            </div>
            <div className={css.map}>
              {renderMap()}
              <button className={`${css.mapViewBtn} ${css.keyTip}`} onClick={() => setOpenTip(!openTip)}>
                <span>Key</span>
              </button>
              {openTip && <img ref={tipRef} className={css.tipImg} src={TipImg} alt='labels' />}
            </div>
          </div>
        </div>
        <div className={css.proteinContainer}>
          {selectedProtein && <ProteinFunction setSelectedProtein={setSelectedProtein} proteinInfo={proteinInfo} pathway={selectedMap?.value} />}
        </div>
      </div>
      {renderMapSvg()}
    </Layout>
  );
}